import React from "react";
import "./Card.scss";

function Card({
  card: {
    content_type = null,
    title,
    media_url_tv = null,
    media_s3_tv_filename = null,
    sub_title = null,
    source = "source inconnue",
    credit_photo = null,
    author = null,
  },
  size = "preview",
  alignMedia = "right",
}) {
  return (
    <div className={`Card Card--${size} Card--align-${alignMedia}`}>
      <div
        className={`Card-content ${
          content_type === "survey" ? "Card-survey" : ""
        }`}
      >
        {content_type !== "survey" ? (
          <div className={`Card-media`}>
            <div className={`Card-image`}>
              <img src={media_s3_tv_filename || media_url_tv} alt={sub_title} />
            </div>
          </div>
        ) : null}

        <div className="Card-text">
          <div className={`Card-text-inner`}>
            <span className={`Card-title`}>{title}</span>
            <ul className={`Card-text-credit`}>
              {source ? (
                <li>
                  Source: <span>{source}</span>
                </li>
              ) : null}
              {credit_photo ? (
                <li>
                  Crédit photo: <span>{credit_photo}</span>
                </li>
              ) : null}{" "}
              {author ? (
                <li>
                  Texte: <span>{author}</span>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
